import React from 'react';
import './resumo.scss';
//Componentes
import Label from '../../../../components/label';
import Form from '../../../../components/form';
import CheckObligation from "../../components/checkObligation";

const LabelField = ({ rightColumn, label, value }) => (
  <div className={rightColumn ? "col-50" : "col" }>
    <Label
      col={rightColumn && "col-50" }
      type=""
      label={label}
      value={value}
    />
  </div>
);

class Resumo extends React.Component {
  componentWillMount() {
    const {
      getListRendaMensalAction,
      getListPatrimonioAction,
    } = this.props;
    getListRendaMensalAction();
    getListPatrimonioAction();
  }

  CheckObligationAssociado = (props) => <CheckObligation {...props} currentStep={this.props.currentStep} />;

  render() {
    const {
      dadosIniciais,
      declaracoesEspecificas,
    } = this.props.resumo;

    const {
      form: {
        dadosIniciais_nomeCompleto,
        dadosIniciais_dataNascimento,
        dadosIniciais_cpf,
        dadosIniciais_telefoneCelular,
        dadosIniciais_ddiTelefoneCelular,
        dadosIniciais_email,
        dadosIniciais_nomeSocial,
      },
    } = dadosIniciais;

    const {
      form: {
        declaracoesEspecificasObrigatorias_faixaRendaMensal,
        declaracoesEspecificasObrigatorias_faixaPatrimonio,
      },
    } = declaracoesEspecificas;

    const {
      dropdownDadosRendaMensalList,
      dropdownDadosPatrimonioList,
    } = this.props.rendaPatrimonioReducer;

    const declaracoesEspecificas_rendaMensalResult = dropdownDadosRendaMensalList.find(function (el) {
      return el.value === Number(declaracoesEspecificasObrigatorias_faixaRendaMensal);
    });
    if (declaracoesEspecificas_rendaMensalResult)
      var declaracoesEspecificasObrigatorias_rendaMensalRotulo = declaracoesEspecificas_rendaMensalResult.name;

    const declaracoesEspecificas_patrimonioResult = dropdownDadosPatrimonioList.find(function (el) {
      return el.value === Number(declaracoesEspecificasObrigatorias_faixaPatrimonio);
    });
    if (declaracoesEspecificas_patrimonioResult)
      var declaracoesEspecificasObrigatorias_patrimonioRotulo = declaracoesEspecificas_patrimonioResult.name;

    const CheckObligationAssociado = this.CheckObligationAssociado;

    return (
      <Form name="resumoForm" noValidate={true}>
      {/* ================================================================================ */}
        <div className="col">
          <Label type="title" label="Dados Iniciais" />
        </div>
        <CheckObligationAssociado field="dadosIniciais_nomeCompleto">
          {(validacoes) =>
            <LabelField label="Nome Completo" value={dadosIniciais_nomeCompleto} />
          }
        </CheckObligationAssociado>
        <CheckObligationAssociado field="dadosIniciais_nomeSocial">
          {(validacoes) =>
            <LabelField label="Nome Social" value={dadosIniciais_nomeSocial} />
          }
        </CheckObligationAssociado>
        <CheckObligationAssociado field="dadosIniciais_dataNascimento">
          {(validacoes) =>
            <LabelField rightColumn label="Data de Nascimento" value={dadosIniciais_dataNascimento} />
          }
        </CheckObligationAssociado>
        <CheckObligationAssociado field="dadosIniciais_cpf">
          {(validacoes) =>
            <LabelField rightColumn label="CPF" value={dadosIniciais_cpf} />
          }
        </CheckObligationAssociado>
        <CheckObligationAssociado field="dadosIniciais_telefoneCelular">
          {(validacoes) =>
            <LabelField
              label="Telefone Celular"
              value={
                `${dadosIniciais_ddiTelefoneCelular.includes("+") ?
                dadosIniciais_ddiTelefoneCelular :
                `+${dadosIniciais_ddiTelefoneCelular}`} ${dadosIniciais_telefoneCelular}`
              }
            />
          }
        </CheckObligationAssociado>
        <CheckObligationAssociado field="dadosIniciais_email">
          {(validacoes) =>
            <LabelField label="E-mail" value={dadosIniciais_email} />
          }
        </CheckObligationAssociado>
        {/* ================================================================================ */}
        <div className="col">
          <Label col="75" type="title" label="Declarações Específicas Obrigatórias " />
        </div>
        <CheckObligationAssociado field="declaracoesEspecificasObrigatorias_faixaRendaMensal">
          {(validacoes) =>
            <LabelField
              label="Renda Mensal"
              value={declaracoesEspecificasObrigatorias_rendaMensalRotulo}
            />
          }
        </CheckObligationAssociado>
        <CheckObligationAssociado field="declaracoesEspecificasObrigatorias_faixaPatrimonio">
          {(validacoes) =>
            <LabelField
              label="Patrimônio"
              value={declaracoesEspecificasObrigatorias_patrimonioRotulo}
            />
          }
        </CheckObligationAssociado>
      </Form>
    );
  }
}

export default Resumo;
